<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
    <!-- 상단 옵션 -->
    <div ref="chartWrapperOpts"
         class="widget-contents-option"
    >
      <div style="flex: 1;"></div>
      <q-select style="width: 100px;"
                class="bs bs-q-sm bs-q-select bs-q-select-default"
                :value="opts.unit"
                :options="showTypeOptions"
                :auth-force="true"
                @change="onChangeChartOptions"
      />
    </div>
    <!-- 컨텐츠 영역 -->
    <div class="widget-contents">
      <!-- 차트 영역 -->
      <non-trend-chart ref="chartInstance"
                         class="widget-contents-chart"
                         :type="opts.chartType"
                         :x-axis="xAxis"
                         :y-axis="yAxis"
                         :tooltip="toolTip"
                         :data="widgetData"
                         :series-options="seriesOptions"
        />
    </div>
  </div>
</template>
<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 객체
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSslVpnServer',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 1,
        self: this,
        opts: {
          unit: 'byte',
          chartType: 'pie'
        },
        title: 'widgetSslVpnServer',
        isLock: false,
        isMove: true,
        isResize: true,
        eventBus: true,
        deviceType: [20],
        restData: {
          result: [],
          unit_time: ''
        },
        seriesOptions: {
          barWidth: '40%'
        },
        widgetData: [],
        applyOptionHeight: true
      }
    },
    computed: {
      xAxis () {
        const xAxisOptions = {}

        if (this.opts.chartType === 'bar') {
          xAxisOptions.axisLabel = {
            formatter: (value) => {
              return this.opts.unit === 'byte' ? `${this.byteConverter(value)}` : `${this.kmgtConverter(value)}`
            }
          }
        }

        return xAxisOptions
      },
      yAxis () {
        const yAxisOptions = {}

        if (this.opts.chartType === 'column') {
          yAxisOptions.axisLabel = {
            formatter: (value) => {
              return this.opts.unit === 'byte' ? `${this.byteConverter(value)}` : `${this.kmgtConverter(value)}`
            }
          }
        }

        return yAxisOptions
      },
      toolTip () {
        return {
          formatter: (params) => {
            const {name, value, marker} = _.isArray(params) ? params[0] : params
            return this.opts.unit === 'byte' ? `${marker} ${name} : <b>${this.byteConverter(value)}${this.restData.unit_time}</b>` : `${marker} ${name} : <b>${this.separateByComma(value)}${this.restData.unit_time}</b>`
          }
        }
      },
      showTypeOptions () {
        return [
          {
            label: this.$t('cmn.traffic'),
            value: 'byte'
          },
          {
            label: this.$t('cmn.numberOfConn'),
            value: 'count'
          }
        ]
      },
      widgetChartMenu () {
        return [
          {
            icon: 'icon-chart-pie',
            label: 'Pie Chart',
            value: 'pie'
          },
          {
            icon: 'icon-chart-bar',
            label: 'Bar Chart',
            value: 'bar'
          },
          {
            icon: 'icon-chart-column',
            label: 'Column Chart',
            value: 'column'
          },
          {
            icon: 'icon-chart-tree-map',
            label: 'Tree Map',
            value: 'treemap'
          }
        ]
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []

          // Series 초기화
          this.$refs.chartInstance.clear()
        }

        const contentsOptions = {}

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams && extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }

        // API 호출
        const byteOptions = {
          widgetType: 'ssl_vpn_server_traffic_top',
          ...contentsOptions
        }
        const countOptions = {
          widgetType: 'ssl_vpn_server_connection_top',
          ...contentsOptions
        }
        const {code, result} = await this.getWidgetData(this.opts.unit === 'byte' ? byteOptions : countOptions)

        // Series 데이터 구성
        if (code === 'ok') {
          this.restData = result

          const sslVpnServer = []

          // TopN 데이터 가공 - 랜덤
          for (const vpnServer of this.restData.result || []) {
            sslVpnServer.push({
              // port: vpnServer.port,
              name: vpnServer.name,
              value: vpnServer.value
            })
          }

          this.widgetData = sslVpnServer
        }

        // Progress 출력 여부
        this.showProgress(false)
      },
      /*
        이름: onChangeChartOptions
        설명: 차트의 출력 타입을 변경한다.
      */
      onChangeChartOptions (value) {
        this.opts.unit = value
        this.getWidgetContentsData()
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-option {
    right: 0;
    display: flex;
    padding-top: 5px;
    padding-right: 5px;
    margin-bottom: 5px;
  }

  .widget-contents {
    display: flex;
  }

  .widget-contents-chart {
    flex: 1 !important;
  }

  th {
    color: #2d5582;
    height: 30px;
    border: 1px solid #c4d8f1;
    background-color: #e2ecf9 !important;
  }

  tr, td {
    border: 1px solid #c4d8f1;
    font-size: 9pt;
  }

</style>
